import { IAuditState } from './interfaces';

export const initState: IAuditState = {
  users: {
    results: [],
    summary: null,
    loading: false,
    error: null,
    lastAuditAt: null,
  },
  communities: {
    results: [],
    loading: false,
    error: null,
    lastAuditAt: null,
  },
  sites: {
    results: [],
    loading: false,
    error: null,
    lastAuditAt: null,
  },
};
